import React from 'react';

const ProgressBar = ({ timeElapsed }) => {
  const progress = (timeElapsed / 5000) * 100; // Calculer la progression en pourcentage

  return (
    <div style={{ width: '100%', backgroundColor: '#e0e0e0', borderRadius: '5px' }}>
      <div
        style={{
          width: `${progress}%`,
          height: '10px',
          backgroundColor: '#FF6F00', // Couleur orange Basic-Fit
          borderRadius: '5px',
          transition: 'width 0.05s linear',
        }}
      ></div>
    </div>
  );
};

export default ProgressBar;